'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../../dist-es6/client/formatters');
const BaseControllerBackedTooltip=require('../../../../../dist-es6/client/directives/tooltips/baseControllerBackedTooltip');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');let

IncidentTooltipDirective=function(_BaseControllerBacked){_inherits(IncidentTooltipDirective,_BaseControllerBacked);function IncidentTooltipDirective(){_classCallCheck(this,IncidentTooltipDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(IncidentTooltipDirective,[{key:'bindings',get:function()
{
return[
'fatigueThresholdStatus',
'deviationThresholdStatus',
'deviation',
'fatigue',
'time',
'description',
'timezone',
'incident'];

}},{key:'templateUrl',get:function()

{
return'/templates/directives/tooltips/incidentTooltip/incidentTooltipTemplate';
}},{key:'controller',get:function()

{
return IncidentTooltipDirectiveController;
}}]);return IncidentTooltipDirective}(BaseControllerBackedTooltip);


const scoreByStatusMap={
Above:2,
At:1,
Below:0,
NotApplicable:0};


const messageByStatusMap=new Map([
[ThresholdStatus.Above,'OVER'],
[ThresholdStatus.At,'NEAR'],
[ThresholdStatus.Below,'UNDER'],
[ThresholdStatus.NotApplicable,'UNDER']]);let


IncidentTooltipDirectiveController=function(){_createClass(IncidentTooltipDirectiveController,null,[{key:'$inject',get:function()
{
return['timeFormattingService'];
}}]);

function IncidentTooltipDirectiveController(timeFormattingService){_classCallCheck(this,IncidentTooltipDirectiveController);
this._timeFormattingService=timeFormattingService;
}_createClass(IncidentTooltipDirectiveController,[{key:'timeString',get:function()

{
return Formatters.formatInLocale(this.time,'MMM DD, YYYY',this.timezone)+' '+this._timeFormattingService.timeInLocale(this.time,this.timezone);
}},{key:'thresholdStatus',get:function()

{
return this._thresholdStatus||(this._thresholdStatus=_.minBy(_.compact([this.fatigueThresholdStatus,this.deviationThresholdStatus]),function(s){return scoreByStatusMap[s.value]}));
}},{key:'thresholdStatusMessage',get:function()

{
return this._thresholdStatusMessage||(this._thresholdStatusMessage=messageByStatusMap.get(this.thresholdStatus));
}}]);return IncidentTooltipDirectiveController}();


module.exports=IncidentTooltipDirective;
module.exports.IncidentTooltipDirectiveController=IncidentTooltipDirectiveController;
//# sourceMappingURL=incidentTooltipDirective.js.map
